/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_Timeline_InvitedInputs */

const en_scene_guestlist_timeline_invited = /** @type {(inputs: Scene_Guestlist_Timeline_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invited to the February Market`)
};

/**
* | output |
* | --- |
* | "Invited to the February Market" |
*
* @param {Scene_Guestlist_Timeline_InvitedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_timeline_invited = /** @type {((inputs?: Scene_Guestlist_Timeline_InvitedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_Timeline_InvitedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_timeline_invited(inputs)
});